/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Ligne de la liste des frais du tunnel.
 * @export
 * @interface FraisTunnelListItemDto
 */
export interface FraisTunnelListItemDto {
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelListItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelListItemDto
     */
    beneficiaire?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FraisTunnelListItemDto
     */
    typeFrais?: string | null;
    /**
     * Affichage du frais sur la page de tarification.
     * @type {boolean}
     * @memberof FraisTunnelListItemDto
     */
    displayedOnPricing?: boolean;
}

/**
 * Check if a given object implements the FraisTunnelListItemDto interface.
 */
export function instanceOfFraisTunnelListItemDto(value: object): value is FraisTunnelListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FraisTunnelListItemDtoFromJSON(json: any): FraisTunnelListItemDto {
    return FraisTunnelListItemDtoFromJSONTyped(json, false);
}

export function FraisTunnelListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraisTunnelListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'beneficiaire': json['beneficiaire'] == null ? undefined : json['beneficiaire'],
        'typeFrais': json['typeFrais'] == null ? undefined : json['typeFrais'],
        'displayedOnPricing': json['displayedOnPricing'] == null ? undefined : json['displayedOnPricing'],
    };
}

export function FraisTunnelListItemDtoToJSON(json: any): FraisTunnelListItemDto {
    return FraisTunnelListItemDtoToJSONTyped(json, false);
}

export function FraisTunnelListItemDtoToJSONTyped(value?: FraisTunnelListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'beneficiaire': value['beneficiaire'],
        'typeFrais': value['typeFrais'],
        'displayedOnPricing': value['displayedOnPricing'],
    };
}

